import { render, staticRenderFns } from "./SourceClassFileModal.vue?vue&type=template&id=24baa2f6&scoped=true"
import script from "./SourceClassFileModal.vue?vue&type=script&lang=js"
export * from "./SourceClassFileModal.vue?vue&type=script&lang=js"
import style0 from "./SourceClassFileModal.vue?vue&type=style&index=0&id=24baa2f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24baa2f6",
  null
  
)

export default component.exports